import { connect } from 'react-redux'
import MainComponent from '../components/main.component'
import store from '../store'
import { LOGOUT } from '../constants'
import mobileView from '../utils/mobile.utils'
import {
  getUserCompanyUpdateInfo,
  openCompanyNotificationDialog,
  closeCompanyNotificationDialog,
  setReadCompanyUpdate
} from '../actions'

/**
 * An High order container class for the the main component.
 *
 * @author  Pragya Gupta
 *
 */

// This method will be called every time
// when the store is updated
const mapStateToProps = (state) => {
  return {
    user: state.oidc.user ? state.oidc.user : store.getState().client.user,
    navItems: navItems,
    path: state.router.location?.pathname,
    showNotiDialog: state.dashboard.showNotiDialog,
    notiIsNotRead: state.dashboard.notiIsNotRead,
    userTaxInfo: state.dashboard.userTaxInfo,
    lang: state.language.lang,
    updateUserEmailSuccess: state.profile.updateUserEmailSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handleManualLogout: () => {
      dispatch({ type: LOGOUT })
    },
    getUserCompanyUpdateInfo: (data) =>
      dispatch(getUserCompanyUpdateInfo(data)),
    openCompanyNotificationDialog: () =>
      dispatch(openCompanyNotificationDialog()),
    closeCompanyNotificationDialog: () =>
      dispatch(closeCompanyNotificationDialog()),
    setReadCompanyUpdate: (data) => dispatch(setReadCompanyUpdate(data))
  }
}

// Passing the result of mapStateToProps,
// mapDispatchToProps, and the parent props
const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

// Connect does not modify the component class passed to it,
// instead it returns a new, connected component class
const MainContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MainComponent)

const navItems = [
  {
    name: 'user',
    content: 'ETUSIVU',
    url: '/dashboard/main'
  },
  {
    name: 'users',
    content: 'ASIAKKAAT',
    url: '/dashboard/customer'
  },
  {
    name: 'plus',
    content: 'UUSI_LASKUT',
    url: '/dashboard/invoice'
  },
  {
    name: 'sticky-note',
    content: 'LASKUT',
    url: '/dashboard/invoice'
  },
  {
    name: 'newspaper-o',
    content: 'KULUT',
    url: '/dashboard/fee'
  },
  {
    name: 'credit-card',
    content: 'PALKAT',
    url: '/dashboard/salary'
  },
  {
    name: 'far fa-briefcase',
    content: 'OPENFORWORK',
    url: '/dashboard/openforwork/assignments'
  }
]

// For mobile views, add nav items
if (mobileView) {
  navItems.push({
    name: 'info-circle',
    content: 'PROFILE',
    url: '/dashboard/profile'
  })
}

export default MainContainer
